<div class="passport-details">
    <div class="form-group my-2">
      <label for="customer-passport-date-of-issue" class="text-xs">Passport Issue Date</label>
      <input 
        type="text" 
        id="customer-passport-date-of-issue" 
        class="form-control" 
        v-model="passport_data.customerPassportDateOfIssue" 
        placeholder="YYYYMMDD"
      />
    </div>
    
    <div class="form-group my-2">
      <label for="passport-valid-to-date" class="text-xs">Passport Expiry Date</label>
      <input 
        type="text" 
        id="passport-valid-to-date" 
        class="form-control" 
        v-model="passport_data.passportValidToDate" 
        placeholder="YYYYMMDD"
      />
    </div>
    
    <div class="form-group my-2">
      <label for="customer-residence-permit-type" class="text-xs">Residence Permit Type</label>
      <select 
        id="customer-residence-permit-type" 
        class="form-select" 
        v-model="passport_data.customerResidencePermitType"
      >
        <option value="Not Selected">Not Selected</option>
        <option value="Asylum Seeker">Asylum Seeker</option>
        <option value="Permanent Resident">Permanent Resident</option>
        <option value="Refugee">Refugee</option>
        <option value="Study Permit">Study Permit</option>
        <option value="Work Permit">Work Permit</option>
        <option value="Temporary Resident">Temporary Resident</option>
      </select>
    </div>
    
    <div class="form-group my-2">
      <label for="customer-residence-permit-number" class="text-xs">Residence Permit Number</label>
      <input 
        type="text" 
        id="customer-residence-permit-number" 
        class="form-control" 
        v-model="passport_data.customerResidencePermitNumber" 
        placeholder="Enter residence permit number"
      />
    </div>
    
    <div class="form-group my-2">
      <label for="customer-residence-permit-country-of-issue" class="text-xs">Residence Permit Country of Issue</label>
      <select 
        id="customer-residence-permit-country-of-issue" 
        class="form-select" 
        v-model="passport_data.customerResidencePermitCountryOfIssue"
      >
        <option value="" disabled selected>Select Country of Issue</option>
        <option v-for="(country, index) in countries" :key="index" :value="country">{{ country }}</option>
      </select>
    </div>
    
    <div class="form-group my-2">
      <label for="customer-residence-permit-date-of-issue" class="text-xs">Residence Permit Issue Date</label>
      <input 
        type="text" 
        id="customer-residence-permit-date-of-issue" 
        class="form-control" 
        v-model="passport_data.customerResidencePermitDateOfIssue" 
        placeholder="YYYYMMDD"
      />
    </div>
    
    <div class="form-group my-2">
      <label for="customer-residence-permit-expiry-date" class="text-xs">Residence Permit Expiry Date</label>
      <input 
        type="text" 
        id="customer-residence-permit-expiry-date" 
        class="form-control" 
        v-model="passport_data.customerResidencePermitExpiryDate" 
        placeholder="YYYYMMDD"
      />
    </div>
    
    <div class="form-group my-2">
      <label for="customer-work-contract-expiry-date" class="text-xs">Work Contract Expiry Date</label>
      <input 
        type="text" 
        id="customer-work-contract-expiry-date" 
        class="form-control" 
        v-model="passport_data.customerWorkContractExpiryDate" 
        placeholder="YYYYMMDD"
      />
    </div>
  </div>